export default "__VITE_ASSET__QsyCW8Ng__"